// 导入八爪鱼前端各组件引擎
import {oTemplateEngine} from './engine/template'
import {oTipsEngine} from "./engine/tips";
import {oConfirmEngine} from "./engine/confirm";
import {oRequestEngine} from "./engine/request";
import {oMethodsEngine} from "./engine/methods";
import {oToolsEngine} from "./engine/tools";
import {oLoadEngine} from "./engine/load";
import {oRouterEngine} from "./engine/router";
import {oRenderEngine} from "./engine/render";
import {oControlEngine} from "./engine/control"
import {oPushEngine} from "./engine/push"
import {oAppletEngine} from "./engine/applet";

import VConosle from "vconsole";

function oEngine(vue) {
  this.vue = vue;
  this.config = {};
  this.passport = {
    id: -1,
    typeID: 1,
    name: "",
    realName: "",
    password: "",
    encryption: false,
    appKey: "",
    token: "",
    remember: false,
    theme: [{name: "default", offset: {menu: 90, content: 135, list: 200}, use: true}, {
      name: "skyblue",
      offset: {menu: 100, content: 150, list: 200},
      use: false
    }],
    authorization: {data: "", company: null, project: "", building: "",},
    language: "CN",
    system: null,   // 当前焦点系统，后台传回。
    project: null,  // 当前焦点项目，后台传回。
    building: null, // 当前焦点建筑，后台传回。
    menu: [],
    tab: [{id: -1, url: "/main/platform/dashboard", name: ""}],
    tabCurrentName: "M_0",
    lock: false,
    bangs: false,
  };
  this.note = "VUE APP Framework";
  this.router = new oRouterEngine(this);
  this.tools = new oToolsEngine(this);
  this.load = new oLoadEngine(this);
  this.applet = new oAppletEngine(this);
  this.push = new oPushEngine(this);
  this.request = new oRequestEngine(this);
  this.tips = new oTipsEngine(this);
  this.confirm = new oConfirmEngine(this);
  this.methods = new oMethodsEngine(this);
  this.control = new oControlEngine(this);
  this.template = new oTemplateEngine(this);
  this.render = new oRenderEngine(this);
  this.init()
}

oEngine.prototype = {
  init: function () {
    this.router.init();
    this.tips.debug("Octopus Engine Start, Page: " + this.router.get().path + ".");
    if (this.config.model == "debug") {
      let vConsole = new VConosle()
    }
  }
};
export {oEngine}





// WEBPACK FOOTER //
// ./src/assets/octopus/main.js